import { Component, Input } from '@angular/core';
import { StatusBadgeColourScheme } from '../status-badge-constants';

@Component({
    selector: 'app-ballot-type-badge',
    templateUrl: './ballot-type-badge.component.html',
    styleUrl: './ballot-type-badge.component.scss',
    standalone: false
})
export class BallotTypeBadgeComponent {
  @Input() name: string = 'ballot-type-badge';
  @Input() ballotType: string = '';
  badgeColourScheme: StatusBadgeColourScheme = StatusBadgeColourScheme.Blue2;
}
